
import React from 'react';

type RequestCardMessageProps = {
  message: string | null;
};

export const RequestCardMessage = ({ message }: RequestCardMessageProps) => {
  if (!message) return null;
  
  // Fonction pour découper un message long
  const shortenMessage = (text: string, maxLength = 150) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div className="mt-2 text-gray-600">
      <div className="mt-2 text-sm text-gray-600 whitespace-pre-line">
        <p>{shortenMessage(message)}</p>
      </div>
    </div>
  );
};
